import { Injectable } from '@angular/core';
import { rdsapPCDBData } from '../../config/rdsap-pcdb-data.config';

@Injectable({
  providedIn: 'root',
})
export class PcdbSearchService {
  private pcdbData = rdsapPCDBData;

  searchPcdbData(searchInput: {
    brandName: string;
    modelName: string;
    searchData: string;
    fuel: string | string[]
  }): any[] {
    const { brandName, modelName, searchData, fuel } = searchInput;
    const searchTerms = searchData?.toLowerCase().split(' ');

    return this.pcdbData.data.pcdf.filter((item) => {
      const brandNameMatch = !brandName || item.brandName === brandName;
      const modelNameMatch = !modelName || item.modelName === modelName;
      const typeMatch = item.type === 'HeatPump' ? item.field2 == fuel : item.field1 == fuel;
      const searchMatch =
        !searchTerms ||
        searchTerms.some(() => {
          return this.itemContainsTerm(item, searchData?.toLowerCase())
        });
      return brandNameMatch && modelNameMatch && searchMatch && typeMatch;
    });
  }


  itemContainsTerm(item: any, term: string): boolean {
    for (const key in item) {
      if (Object.prototype.hasOwnProperty.call(item, key)) {
        const value = item[key];
        if (typeof value === 'string' && value.toLowerCase().includes(term)) {
          return true;
        }
      }
    }
    return false;
  }

}
